import { useMutation, useQueryClient } from 'react-query';
import { ace_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { bucketsKeys } from '../../cache-keys/bucketsKeys';

export function useProcessApplication() {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation({
    mutationFn: ace_api.patchProcessApplication(api),
    onSuccess: async () => {
      await client.invalidateQueries([bucketsKeys.root()]);
    },
  });
}
